export const descendingComparator = (a, b, orderBy) => {
  const valA = a?.[orderBy];
  const valB = b?.[orderBy];

  if (valB == null) return -1;
  if (valA == null) return 1;

  if (typeof valA === 'string') {
    return valB.localeCompare(valA);
  }

  return valB < valA ? -1 : valB > valA ? 1 : 0;
};

export const getComparator = (order, orderBy) => {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
};

export const stableSort = (array, comparator) => {
  const stabilized = array.map((el, index) => [el, index]);
  stabilized.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilized.map((el) => el[0]);
};